module.exports = __webpack_public_path__ + "img/instagram_logo.576a3934.png";